"use client";

import SharedHeader from "@/components/SharedHeader";
import FaqList from "@/components/FaqList";
import { useT } from "@/lib/locale-context";
import type { TranslationKey } from "@/lib/i18n";

const FAQ_COUNT = 20;

export default function FaqPage() {
  const t = useT();
  const entries = Array.from({ length: FAQ_COUNT }, (_, i) => ({
    q: t(`faq.q${i + 1}` as TranslationKey),
    a: t(`faq.a${i + 1}` as TranslationKey),
  }));

  return (
    <div className="min-h-screen bg-gray-50">
      <SharedHeader />

      <main className="max-w-3xl mx-auto px-4 sm:px-6 pt-6 pb-12 space-y-8">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 tracking-tight text-center">
          {t("faq.title")}
        </h1>

        <FaqList entries={entries} />
      </main>
    </div>
  );
}
